module.exports = __webpack_public_path__ + "static/media/sl.18e65344.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sl.svg
// module id = 248
// module chunks = 0